import React from "react";
import { useTranslation } from "react-i18next";
import {
  IconCopyright,
  IconSearch,
  IconSquareBlogBlack,
  IconSquareFacebookBlack,
  IconSquareInstagramBlack,
} from "../icons";
import { Link, useHistory } from "react-router-dom";
import { Select } from "antd";
import { LIST_LINK_FOOTER } from "../../constants/common";

const Footer: React.FC = () => {
  const { t } = useTranslation(["common", "notification"]);
  const history = useHistory();

  const listLinkFooter = LIST_LINK_FOOTER.map((item: any) => {
    return {
      label: item.label,
      value: item.link,
    };
  });

  const handleLinkPage = async (value: any) => {
    if (value != "/") {
      window.location.href = value;
    }
  };

  return (
    <footer className="footer">
      <div className="hidden md:block bg-white py-20">
        <div className="container mx-auto">
          <div className="grid grid-cols-3 gap-20">
            {/* col 1 */}
            <div className="flex flex-col gap-8">
              <a href={""} className="text-black-1 text-md">
                {t("common:Về Atadi")}
              </a>
              <a href={""} className="text-black-1 text-md">
                {t("common:Liên hệ")}
              </a>
              <a
                href={`${process.env.REACT_APP_URL_ATADI}/dieu-khoan-su-dung`}
                className="text-black-1 text-md"
              >
                {t("common:Điều khoản sử dụng")}
              </a>
              <a
                href={`${process.env.REACT_APP_URL_ATADI}/quy-che-hoat-dong`}
                className="text-black-1 text-md"
              >
                {t("common:Quy chế hoạt động")}
              </a>
              <a
                href={`${process.env.REACT_APP_URL_ATADI}/chinh-sach-bao-mat`}
                className="text-black-1 text-md"
              >
                {t("common:Chính sách bảo mật")}
              </a>
              <a
                href={"https://www.vntrip.vn/cam-nang/"}
                target={"_blank"}
                className="text-black-1 text-md"
              >
                {t("common:Blog du lịch")}
              </a>
              <a
                href={`${process.env.REACT_APP_URL_ATADI}/tra-cuu-don-hang`}
                className="text-black-1 text-md"
              >
                {/* <IconSearch /> */}
                <span className="text-md">{t("common:Tra cứu đơn hàng")}</span>
              </a>
            </div>
            {/* col 2 */}
            <div className="flex flex-col gap-8">
              <p className="text-black-1 text-xl font-medium">
                {t("common:CÔNG TY TNHH ATADI")}
              </p>
              <p className="text-black-1 text-md">
                {t("common:ADDRESS_COMPANY_BRANCH_HANOI")}
              </p>
              <p className="text-black-1 text-md">
                {t("common:ADDRESS_COMPANY_BRANCH_HCM")}
              </p>
              <p className="text-black-1 text-md">Email: hotro@atadi.vn</p>
            </div>
            {/* col 3 */}

            <div>
              <p className="text-black-1 text-md mb-16">
                <span className="text-red-primary font-medium">
                  {t("common:Du lịch thông minh")}!
                </span>{" "}
                <span>
                  {t(
                    "common:Đăng ký nhận tin để lên kế hoạch cho kỳ nghỉ tới ngay từ bây giờ"
                  )}
                  .
                </span>
              </p>

              <a
                href={`${process.env.REACT_APP_URL_ATADI}/tra-cuu-don-hang`}
                className="text-black-1 text-md flex items-center gap-4"
              >
                <IconSearch fill="#262626" />
                <span className="text-md">{t("common:Tra cứu đơn hàng")}</span>
              </a>

              {/* <FormRegister />

                            <div style={{ maxWidth: 336 }}>
                                <img alt="Logo bộ công thương" src={bct} />
                            </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden">
        <div className="container">
          <div className="footer__select">
            <Select
              options={[
                ...listLinkFooter,
                {
                  value: `${process.env.REACT_APP_URL_ATADI}/tra-cuu-don-hang`,
                  label: "Tra cứu đơn hàng",
                },
              ]}
              defaultValue={`${process.env.REACT_APP_URL_ATADI}/ve-atadi`}
              className="w-full"
              onSelect={(e) => handleLinkPage(e)}
            />

            <div className="flex flex-col gap-8 my-28">
              <p className="text-black-1 text-md font-semibold">
                {t("common:CÔNG TY TNHH ATADI")}
              </p>
              <p className="text-black-1 text-md">
                {t("common:ADDRESS_COMPANY_BRANCH_HANOI")}
              </p>
              <p className="text-black-1">
                {t("common:ADDRESS_COMPANY_BRANCH_HCM")}
              </p>
              <p className="text-black-1">Email: hotro@atadi.vn</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black-1">
        <div className="container mx-auto py-16">
          <div className="flex flex-col gap-12 md:flex-row items-center justify-between">
            <div className="text-white text-sm text-center md:text-left">
              <span>
                {t("common:Bản quyền")} <IconCopyright />
              </span>{" "}
              <div className="md:hidden">{/* <br /> */}</div>
              2024 Vntrip.vn I {t("common:Giấy phép kinh doanh dịch vụ")}
            </div>
            <div className="flex items-center gap-16">
              <div className="flex gap-8 items-center">
                <IconSquareFacebookBlack />
                <span className="text-white text-sm">Facebook</span>
              </div>
              <div className="flex gap-8 items-center">
                <IconSquareInstagramBlack />
                <span className="text-white text-sm">Instagram</span>
              </div>
              <div className="flex gap-8 items-center">
                <IconSquareBlogBlack />
                <span className="text-white text-sm">
                  {t("common:Blog du lịch")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
